import FbButton from 'components/FbUI/FbButton'
import { cn } from 'components/UI/cn'
import React from 'react'

export interface DataTableFilterButtonsProps {
  isActive: boolean
  open: boolean
  title: string
  activeValueLabel: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}

const FilterButtonComponent = React.forwardRef(
  (props: DataTableFilterButtonsProps, ref) => {
    return (
      <FbButton
        ref={ref}
        variant={'secondary'}
        type="button"
        className={cn(
          'flex-1 w-100 relative border-gray-300 text-[#344054] min-h-[40px] hover:text-[#344054]',
          {
            'bg-[#F9F9FB]': props.open,
            'border-[#5a755e]': props.isActive,
          }
        )}
        onClick={props.onClick}
      >
        <div
          className={cn('w-full text-left', {
            'pr-8': props.isActive,
          })}
        >
          {props.title}:&nbsp;
          <span
            className={
              'overflow-hidden whitespace-nowrap overflow-ellipsis font-bold'
            }
          >
            {props.activeValueLabel}
          </span>
        </div>
      </FbButton>
    )
  }
)
FilterButtonComponent.displayName = 'FilterButton'

export const FilterButton = FilterButtonComponent
